// import { createClient } from '@clickhouse/client-web';
import { BirdData } from '../components/pages/SpeciesBirdIdentification';
// import evia1 from '../assets/data/greece-birds-evia1.json';
// import evia2 from '../assets/data/greece-birds-evia2.json';
// import evia3 from '../assets/data/greece-birds-evia3.json';
// import thrace1 from '../assets/data/greece-birds-thrace1.json';
// import thrace2 from '../assets/data/greece-birds-thrace2.json';
// import thrace3 from '../assets/data/greece-birds-thrace3.json';
// import thrace4 from '../assets/data/greece-birds-thrace4.json';
// import thrace5 from '../assets/data/greece-birds-thrace5.json';
// import thrace6 from '../assets/data/greece-birds-thrace6.json';

// const allThraceDetections = [
//   ...(thrace1 as any[]),
//   ...(thrace2 as any[]),
//   ...(thrace3 as any[]),
//   ...(thrace4 as any[]),
//   ...(thrace5 as any[]),
//   ...(thrace6 as any[]),
// ];

// const allEviaDetections = [...(evia1 as any[]), ...(evia2 as any[]), ...(evia3 as any[])];

// Initialize ClickHouse client
// const clickhouseClient = createClient({
//   url: 'https://db.guarden.naturalis.io',
//   // pathname: '/clickhouse/',
//   username: 'guarden',
//   password: 'Qr4aXCX7przuL8uJ',
// });

/**
 * Custom error for database query failures.
 */
class DatabaseQueryError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DatabaseQueryError';
  }
}

async function fetchDataFile(fileName: string): Promise<any[]> {
  try {
    const response = await fetch(`/data/${fileName}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${fileName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${fileName}:`, error);
    throw new DatabaseQueryError(`Failed to fetch data from ${fileName}`);
  }
}

/**
 * Fetches bird detection data from the Thrace dataset.
 * @param limit An optional limit for the number of results.
 * @returns A promise that resolves to an array of BirdData objects.
 */
// export async function fetchThraceDetections(limit?: string): Promise<BirdData[]> {
//   try {
//     const query = `
//       SELECT
//         thrace_id AS key,
//         mic_name AS sensorId,
//         begdatetime	 AS timestamp,
//         common_name AS commonName,
//         scientific_name AS scientificName,
//         score AS identificationProbability,
//         control_or_studyarea AS controlOrStudyarea
//       FROM guarden.thrace
//       ${limit ? `LIMIT ${limit}` : ''}
//     `;

//     const result = await clickhouseClient.query({
//       query,
//       format: 'JSONEachRow',
//     });

//     // Consume the stream ONCE and store the result
//     const data: BirdData[] = await result.json();

//     // Map over the data to convert the timestamp string to a Date object.
//     return data.map((item) => ({
//       ...item,
//       identificationProbability: Number(item.identificationProbability) * 100,
//       timestamp: new Date(item.timestamp).toISOString(),
//     }));
//   } catch (error) {
//     console.error('Error fetching Thrace detections:', error);
//     throw new DatabaseQueryError('Failed to fetch Thrace detection data.');
//   }
// }

export async function fetchThraceDetections(limit?: string): Promise<BirdData[]> {
  try {
    const fileNames = [
      'greece-birds-thrace1.json',
      'greece-birds-thrace2.json',
      'greece-birds-thrace3.json',
      'greece-birds-thrace4.json',
      'greece-birds-thrace5.json',
      'greece-birds-thrace6.json',
    ];
    const allDataPromises = fileNames.map(fetchDataFile);
    const allDataArrays = await Promise.all(allDataPromises);
    const allThraceDetections = allDataArrays.flat();

    const dataToProcess = limit ? allThraceDetections.slice(0, Number(limit)) : allThraceDetections;

    return dataToProcess
      .map((item) => {
        const timestamp = item.timestamp ? new Date(item.timestamp) : null;
        if (!timestamp || isNaN(timestamp.getTime())) {
          console.warn('Skipping item due to missing or invalid timestamp:', item.timestamp);
          return null;
        }

        // Mapping and converting data to match the BirdData interface
        return {
          key: Number(item.key), // Convert key from string to number
          sensorId: item.sensorId,
          timestamp: timestamp.toISOString(),
          commonName: item.commonName,
          scientificName: item.scientificName,
          identificationProbability: Number(item.identificationProbability) * 100, // Convert score to number
          conservationStatus: undefined, // Add missing optional fields
          protectionStatus: undefined, // Add missing optional fields
          controlOrStudyarea: item.controlOrStudyarea,
        };
      })
      .filter(Boolean) as BirdData[];
  } catch (error) {
    console.error('Error fetching Thrace detections:', error);
    throw new DatabaseQueryError('Failed to fetch Thrace detection data.');
  }
}

/**
 * Fetches bird detection data from the Evia dataset.
 * @param limit An optional limit for the number of results.
 * @returns A promise that resolves to an array of BirdData objects.
 */
// export async function fetchEviaDetections(limit?: string): Promise<BirdData[]> {
//   try {
//     const query = `
//       SELECT
//         evia_id AS key,
//         mic_name AS sensorId,
//         begdatetime AS timestamp,
//         scientific_name AS scientificName,
//         score AS identificationProbability,
//         control_or_studyarea AS controlOrStudyarea
//       FROM guarden.evia
//       ${limit ? `LIMIT ${limit}` : ''}
//     `;

//     const result = await clickhouseClient.query({
//       query,
//       format: 'JSONEachRow',
//     });
//     const data: BirdData[] = await result.json();
//     return data.map((item) => {
//       const [datePart, timePart] = item.timestamp.split(' ');
//       const [day, month, year] = datePart.split('/');
//       const [hour, minute] = timePart.split(':');
//       const standardDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//       const standardTime = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
//       const isoDateString = `${standardDate}T${standardTime}:00.000Z`;
//       const validDate = new Date(isoDateString);

//       if (isNaN(validDate.getTime())) {
//         console.error(`Invalid date found: ${item.timestamp}. The ISO string attempted was: ${isoDateString}`);
//         return {
//           ...item,
//           timestamp: new Date().toISOString(), // Fallback to current time
//         };
//       }

//       return {
//         ...item,
//         identificationProbability: Number(item.identificationProbability) * 100,
//         timestamp: validDate.toISOString(),
//       };
//     });
//   } catch (error) {
//     console.error('Error fetching Evia detections:', error);
//     throw new DatabaseQueryError('Failed to fetch Evia detection data.');
//   }
// }

export async function fetchEviaDetections(limit?: string): Promise<BirdData[]> {
  try {
    const fileNames = ['greece-birds-evia1.json', 'greece-birds-evia2.json', 'greece-birds-evia3.json'];
    const allDataPromises = fileNames.map(fetchDataFile);
    const allDataArrays = await Promise.all(allDataPromises);
    const allEviaDetections = allDataArrays.flat();

    const dataToProcess = limit ? allEviaDetections.slice(0, Number(limit)) : allEviaDetections;

    return dataToProcess
      .map((item) => {
        if (!item.timestamp) {
          console.warn('Skipping item due to missing timestamp:', item);
          return null;
        }

        const [datePart, timePart] = item.timestamp.split(' ');
        if (!datePart || !timePart) {
          console.warn('Skipping item due to malformed timestamp:', item.timestamp);
          return null;
        }

        const [day, month, year] = datePart.split('/');
        const [hour, minute] = timePart.split(':');
        const standardDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        const standardTime = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
        const isoDateString = `${standardDate}T${standardTime}:00.000Z`;
        const validDate = new Date(isoDateString);

        if (isNaN(validDate.getTime())) {
          console.warn(`Skipping item due to invalid date: ${item.timestamp}. ISO string attempted: ${isoDateString}`);
          return null;
        }

        // Mapping and converting data to match the BirdData interface
        return {
          key: Number(item.key), // Convert key from string to number
          sensorId: item.sensorId,
          timestamp: validDate.toISOString(),
          // Use scientificName as a fallback for commonName as it is missing from the data
          commonName: item.scientificName,
          scientificName: item.scientificName,
          identificationProbability: Number(item.identificationProbability) * 100, // Convert score to number
          conservationStatus: undefined, // Add missing optional fields
          protectionStatus: undefined, // Add missing optional fields
          controlOrStudyarea: item.controlOrStudyarea,
        };
      })
      .filter(Boolean) as BirdData[];
  } catch (error) {
    console.error('Error fetching Evia detections:', error);
    throw new DatabaseQueryError('Failed to fetch Evia detection data.');
  }
}
